"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var _theme = require("./constants/theme");
var GlobalStyle = (0, _styledComponents.createGlobalStyle)(["html{font-size:10px;--min-viewport:320;--max-viewport:", ";}*{box-sizing:border-box;}strong{font-weight:500;}body{margin:0;padding:0;color:", ";font-family:", ";", ";}p{margin:2.4rem 0;}li{list-style:none;}input,textarea{font:inherit;}button{background:none;border:none;cursor:pointer;font-family:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.mediaQueriesValues.xl;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.neutral['70'];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontFamily.body;
}, function (_ref4) {
  var theme = _ref4.theme;
  return (0, _theme.getFontCss)(theme.fontSizes.body.regular);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontFamily.body;
});
var _default = exports["default"] = GlobalStyle;
//# sourceMappingURL=globalStyling.js.map